import { get } from "lodash-es";
import { type FC, useCallback } from "react";
import type { Doc } from "sharedb/lib/client";

import type {
  EmbedFieldType,
  OEmbedDataType,
  PathType,
  WorksheetType,
} from "../../../../shared/types/worksheet";

import { showOEmbedModal } from "./EmbedModal";

import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import { PencilEditIcon } from "mds/icons";

interface EmbedProps {
  doc: Doc<WorksheetType>;
  path: PathType;
  url?: string;
}

export const EditEmbedButton: FC<EmbedProps> = ({ doc, path, url }) => {
  const updateDoc = useCallback(
    (newData: OEmbedDataType) => {
      const fieldData = get(doc.data, path) as EmbedFieldType;
      const newFieldData = { ...fieldData, ...newData };
      doc.submitOp([{ p: path, ld: fieldData, li: newFieldData }]);
    },
    [doc, path],
  );

  const onEdit = () => {
    if (url) showOEmbedModal(url, updateDoc);
  };

  return (
    <LegacyButton kind="secondary" title={t("common.edit")} iconOnly onClick={onEdit}>
      <PencilEditIcon />
    </LegacyButton>
  );
};
